import { Component, Input, OnInit } from '@angular/core';
import { Point } from '../../../../../models/pointWidget.model';

@Component({
  selector: 'app-infobox',
  templateUrl: './infobox.component.html',
  styleUrls: ['./infobox.component.css']
})
export class InfoboxComponent implements OnInit {

  @Input() pointData: Point;
  @Input() penetration?: Point;
  @Input() t?: any = null;
  @Input() options?: any = {};
  @Input() enableAutoGrey ?= true;

  constructor() { }

  ngOnInit() { }

  getGrayInfobox() {
    if ((!this.getAutoGray()) || (this.pointData && this.pointData.current && this.pointData.current !== 0 && this.pointData.current != null)) {
      return '';
    }

    return  'grayinbox';
  }

  getGrayInfoboxValue() {
    if ((!this.getAutoGray()) || (this.pointData && this.pointData.current && this.pointData.current !== 0 && this.pointData.current != null)) {
      return '';
    }

    return  'grayinbox-value';
  }

  getGrayInfoboxPreValue() {
    if ((!this.getAutoGray()) || (this.pointData && this.pointData.current && this.pointData.current !== 0 && this.pointData.current != null)) {
      return '';
    }

    return  'grayinbox-prev-value';
  }

  getPrevious() {
    if (this.pointData) {
      return this.options.dynamic ? this.formatDynamic(this.pointData.previous) : this.pointData.previous;
    }

    return '';
  }

  getCurrent() {
    if (this.pointData) {
      return this.options.dynamic ? this.formatDynamic(this.pointData.current) : this.pointData.current;
    }

    return '';
  }

  getCurrentMultiplier() {
    if (this.pointData && this.options.dynamic) {
      return this.formatDynamicMultiplier(this.pointData.current);
    }

    return ''
  }

  getPreviousMultiplier() {
    if (this.pointData  && this.options.dynamic) {
      return this.formatDynamicMultiplier(this.pointData.previous);
    }

    return ''
  }

  private getAutoGray(): boolean {
    if (!this.enableAutoGrey) {
      return this.enableAutoGrey;
    } else if (this.options && this.options.enableAutoGrey === false) {
      return this.options.enableAutoGrey;
    }

    return true;
  }

  formatDynamic(x: number): number {
    switch (true) {
      case Math.abs(+x) >= 1000000:
        return (x / 1000000);
      case Math.abs(+x) >= 1000:
        return x / 1000;
      default:
        return x;
    }
  }

  formatDynamicMultiplier(x: number): string {
    if (!this.pointData && !this.pointData.unitOfMeasure) {
      return '';
    }

    switch (true) {
      case Math.abs(+x) >= 1000000:
        return this.pointData.unitOfMeasure.trim().indexOf('M') < 0 ? 'M' : '';
      case Math.abs(+x) >= 1000:
        return this.pointData.unitOfMeasure.trim().indexOf('K') < 0 ? 'K' : '';
      default:
        return '';
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/widget/infobox/infobox.component.ts